export default "__VITE_ASSET__CVAjsY14__"